
import VueNumber from 'vue-number-animation'

export default ({ Vue }) => {
  Vue.use(VueNumber)
}
